<!-- Modal Header -->
<div class="modal-header modal-head">
    <div class="modal-titles">MODIFICA SUPERVISORE</div>
</div>

<!-- Modal body -->
<div class="modal-body">
    <form [formGroup]="formBuilder">
        <div class="row">
            <div class="col-12">
                <div class="m-3">
                    <label for="field_name" class="form-label label-fw">
                        Nome gestione *
                    </label>
                    <input formControlName="name" name="name" type="text"
                        [ngClass]="{'is-invalid': form.status === 'INVALID' && form.touched === true && formControls.name.errors}"
                        class="form-control form-fw " id="field_name" placeholder="Nome">
                    <div class="invalid-feedback" *ngIf="form.touched">
                        <span *ngIf="formControls.name.errors && formControls.name.errors?.required">
                            Nome gestione è obbligatorio
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-12">
            <div class="m-3">
                <label for="field_name" class="form-label label-fw">
                    Stores associati
                </label>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item px-0 flex" 
                        [ngClass]="{'is-deleted': store.del === true}"
                        *ngFor="let store of stores">
                        <div class="stores-list">
                            <a href="#/store/store/{{store.id}}" target="_blank"  rel="noopener">
                                <i class="fas fa-link ora clickable blu"></i>
                            </a>
                            <span [hidden]="store.del">
                                {{store.dealerDescription}} - {{store.titleSeo}}
                            </span>
                            <del [hidden]="!store.del">
                                {{store.dealerDescription}} - {{store.titleSeo}}   
                            </del>
                        </div>      
                        <i [hidden]="!store.del" (click)="clickButtonChangeDelStore(store.id,false)" class="fas fa-times clickable red"></i>
                        <i [hidden]="store.del" (click)="clickButtonChangeDelStore(store.id,true)" class="fas fa-times clickable red"></i>
                    </li>
                    <li class="list-group-item px-0" *ngIf="stores.length == 0">
                        Non esistono stores associati
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-12">
            <div class="m-3">
                <label for="field_name" class="form-label label-fw">
                    Utenti associati
                </label>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item px-0 flex" 
                        [ngClass]="{'is-deleted': user.del === true}"
                        *ngFor="let user of users">
                        <div class="stores-list">
                            <span   [hidden]="user.del">
                                {{user.email}} - {{user.name}} {{user.surname}}
                            </span>
                            <del    [hidden]="!user.del">
                                {{user.email}} - {{user.name}} {{user.surname}} 
                            </del>
                        </div>
                        <i [hidden]="!user.del" (click)="clickButtonChangeDelUser(user.id,false)" class="fas fa-times clickable red"></i>
                        <i [hidden]="user.del" (click)="clickButtonChangeDelUser(user.id,true)" class="fas fa-times clickable red"></i>
                    </li>
                    <li class="list-group-item px-0" *ngIf="users.length == 0">
                        Non esistono utenti associati
                    </li>
                </ul>

            </div>
        </div>
    </div>



    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            <button type="button" class="btn btn-fw text me-3"
                [disabled]="(form.status === 'INVALID' && form.touched === true) || form.touched === false "
                (click)="clickButtonSave()">Salva</button>
            <button type="button" class="btn btn-outline-fw text"
                (click)="clickButtonCancel()">Annulla</button>
        </div>
    </div>
</div>